import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface SpinnerProps {
  className?: string;
  label?: string;
}

/**
 * Spinner atom — single shared loading indicator (W3/W14).
 * Built on the lucide Loader2 icon; replaces the dozens of inline
 * `Loader2`-based loading blocks and the raw PageLoader in router.tsx.
 */
export function Spinner({ className, label }: SpinnerProps) {
  return (
    <div
      role="status"
      className={cn('flex items-center justify-center gap-2 text-muted-foreground', className)}
    >
      <Loader2 className="h-5 w-5 animate-spin" />
      {label ? <span className="text-sm">{label}</span> : null}
      <span className="sr-only">{label ?? 'Loading'}</span>
    </div>
  );
}
